import getComputedVariableValue from "@/utils/get-computed-variable-value";
import { useEffect } from "react";

const useSetChatVariableHeight = (show: boolean) => {
	useEffect(() => {
		// store original height in variable
		// update --mobile-chat-height to zero if !show
		const val = getComputedVariableValue('--mobile-chat-height');
		if (!show) {
			document.documentElement.style.setProperty('--mobile-chat-height', "0px");
		} else {
			// reset to original value if show
			document.documentElement.style.setProperty('--mobile-chat-height', val || '50px');
		}

		// on unmount, reset too
		return () => {
			document.documentElement.style.setProperty('--mobile-chat-height', val || '50px');
		};
	}, [show]);
};

export default useSetChatVariableHeight;